<template>
  <div class="live">
    <iframe name="live" width="100%" height="100%" frameborder=0 src="http://e.cippe.com.cn/live/jzyx_en"></iframe>
  </div>
</template>

<script>
export default {
  mounted(){
    sessionStorage.setItem('selected','/live')
  }
}
</script>

<style scoped>
  .live{
    width: calc(100% + 17px);
    height: calc(100% - 55px);
  }

</style>